<template>
  <div>
    <card class="custom-shadow-card-header">
      <div class="row content-add-btn padbtn">
        <template v-if="!$slots.dialogForm">
          <header-add
            :typeEvent="addProperties.eventType"
            :route="`/${
              addProperties.routeToCreate ? addProperties.routeToCreate : route
            }/create`"
            v-if="isCreate()"
          />
        </template>
        <template v-else>
          <header-add
            @openModal="$emit('openModal', false)"
            v-if="isCreate()"
          />
        </template>
      </div>
      <div v-if="isIndex()">
        <card-header
          :propPagination="pagination"
          :showRefresh="true"
          @searchedQuery="searchedQuery"
          @refreshTable="refreshTable"
          class="mr-3 mt-3"
        ></card-header>
        <master-table
          :columns="tableProperties.tableColumns"
          :infoTable="queriedData"
          :showColumnImage="tableProperties.showColumnImage"
          :showColumnStatus="true"
          :widthColumnStatus="tableProperties.widthColumnStatus"
          :defaultSort="tableProperties.defaultSort"
          :cellStyle="tableProperties.handleCellStyle"
        >
          <template slot="addColumns">
            <template v-for="(badge, index) in dataBadges">
              <table-column-badges
                :key="index"
                :prop="`${badge.data}[0].${badge.property}`"
                :min-width="badge.minWidth"
                :label="badge.columnLabel"
                :fromData="badge.data"
                :textBadge="badge.property"
                v-if="showColumn(badge.show)"
              />
            </template>
          </template>
          <template slot="addColumnsOperations">
            <table-columns-operations
              v-if="isShow() || isUpdate() || isDelete()"
              :canDisable="true"
              :minWidth="
                tableProperties.widthOperations
                  ? tableProperties.widthOperations
                  : 125
              "
              @handleDelete="handleDelete"
              @handleEdit="handleEdit"
              @handleView="handleView"
              @handleActivate="handleActivate"
              :howMuchTimePassed="tableProperties.howMuchTimePassed"
            />
          </template>
        </master-table>
      </div>
      <not-index-permissions v-else />
      <card-footer ref="cardfooter" :propPagination="pagination" />
      <export-tables
        v-if="showExportTables"
        :pdf="exportProperties.pdf"
        :xls="exportProperties.xls"
      />
      <br />
      <template v-if="showDrawer">
        <el-drawer
          :visible.sync="modals.read"
          direction="rtl"
          :with-header="false"
          :size="
            showProperties && showProperties.size ? showProperties.size : '40%'
          "
          :before-close="handleClose"
        >
          <show-as-drawer
            v-if="rowData && renderContentShowDialog"
            :drawerProperties="{
              tableColumns: tableProperties.tableColumns,
              addColumns: tableProperties.addColumns,
              rowData: {
                ...rowData,
                methodMap: tableProperties.map ? tableProperties.map : null,
                model: tableProperties.model ? tableProperties.model : null,
              },
              showBusinessesTag: showBusinessesTag,
              showModulesTag: showModulesTag,
              showSubcategoriesTag: showSubcategoriesTag,
              effectTags: tableProperties.effectTags,
            }"
          />
        </el-drawer>
      </template>
      <template v-else>
        <el-dialog
          top="2%"
          :width="
            showProperties && showProperties.size ? showProperties.size : '70%'
          "
          v-if="isShow()"
          :title="getTitle"
          :visible.sync="modals.read"
          :before-close="handleClose"
        >
          <show-as-dialog
            v-if="rowData && renderContentShowDialog"
            :dialogProperties="{
              tableColumns: tableProperties.tableColumns,
              addColumns: tableProperties.addColumns,
              rowData: {
                ...rowData,
                methodMap: tableProperties.map ? tableProperties.map : null,
                model: tableProperties.model ? tableProperties.model : null,
              },
              showBusinessesTag: showBusinessesTag,
              showModulesTag: showModulesTag,
              showSubcategoriesTag: showSubcategoriesTag,
              effectTags: tableProperties.effectTags,
            }"
          />
        </el-dialog>
      </template>
      <slot name="dialogForm"></slot>
    </card>
  </div>
</template>
<script>
import { Drawer } from 'element-ui';
import { MixinNotification } from 'src/mixins/mixin-notification';
import Computed from './master-computed';
import Methods from './master-main-methods';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTable from 'src/mixins/mixin-table';
import Props from './master-main-props';
import ShowAsDialog from 'src/components/Masters/ShowAsDialog';
import ShowAsDrawer from 'src/components/Masters/ShowAsDrawer';
import Watch from './master-watch';

export default {
  name: 'master-main',
  components: {
    [Drawer.name]: Drawer,
    [ShowAsDrawer.name]: ShowAsDrawer,
    [ShowAsDialog.name]: ShowAsDialog,
  },
  props: Props,
  mixins: [
    MixinAlert,
    MixinDialog,
    MixinLoading,
    MixinMenu,
    MixinPermissions,
    MixinTable,
    MixinNotification,
  ],
  data() {
    return {
      model: {},
      renderContentShowDialog: true,
    };
  },
  watch: Watch,
  computed: Computed,
  methods: Methods,
  mounted() {
    let route = this.getRoute;
    this.selectedItemOnMenu(route.split('/')[0]);
  },
  destroyed() {
    let route = this.getRoute;
    this.deselectedItemOnMenu(route.split('/')[0]);
  },
};
</script>
